/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const CREATE_RETRIEVALS_URL = `${API_URL}/retrievals`;
export const GET_MY_RETRIEVALS_URL = `${API_URL}/retrievals/myretrivals`;
export const PROCUREMENT_RETRIEVALS_URL = `${API_URL}/retrievals/procurementlist`;
export const PROCUREMENT_RETRIEVALS_DECISION_URL = `${API_URL}/retrievals/procurementdecision`;
export const ACCOUNT_RETRIEVALS_URL = `${API_URL}/retrievals/accountlist`;
export const ACCOUNT_RETRIEVALS_DECISION_URL = `${API_URL}/retrievals/accountdecision`;
